import { registerApi as api } from '../../api';


export const fetchTn_form_VIData = async (year) => {
    console.log("Fetching TN Form VI data for year:", year);

    const client_id = sessionStorage.getItem("selectedClient"); // move assignment outside

    try {
        const response = await api.get(`/get_tn_form_vi`, {
            params: {
                current_year: year,
                client_id: client_id
            }
        });
        return response.data;
    } catch (error) {
        throw error.response ? error.response.data.error : error.message;
    }
};


export const updateTn_form_VI = async (id, tn_form_vi_data) => {
    try {
        const token = sessionStorage.getItem('token');
        const response = await api.put(`/update_tn_form_vi/${id}`, tn_form_vi_data, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })
        return response.data
    } catch (error) {
        throw error.response ? error.response.data.error : error.message;
    }
}


export const deleteTn_form_VI = async (id) => {
    try {
        const token = sessionStorage.getItem('token');
        const response = await api.delete(`/delete_tn_form_vi/${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })
        return response.data
    } catch (error) {
        throw error.response ? error.response.data.error : error.message
    }
}

// export const Tn_form_VIUpload = async (tn_form_vi_data_input) => {
//     try {
//         const token = sessionStorage.getItem('token');
//         const selectedClientID = sessionStorage.getItem('selectedClient')
//         const response = await api.post(`/upload_tn_form_vi`, tn_form_vi_data_input, {
//             headers: {
//                 'Authorization': `Bearer ${token}`,
//                 'Content-Type': 'multipart/form-data'
//             },
//             params : {
//                 'selectedClientID' : selectedClientID
//             }
//         });
//         return {
//             data: response,
//             status: response.status,
//         }
//     } catch (error) {
//         throw error.response.data.error;
//     }
// }


export const Tn_form_VIUpload = async (fileData) => {
    const formData = new FormData();
    formData.append('file', fileData);
    
    const token = sessionStorage.getItem('token');
    const selectedClientID = sessionStorage.getItem('selectedClient')
    const response = await api.post('/upload_tn_form_vi', formData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      },
      params : {
        'selectedClientID' : selectedClientID
      },
            // IMPORTANT: Don't reject on non-200 status for partial uploads
            validateStatus: (status) => status === 200 || status === 400
        }
    );
    
    return response.data;
};



export const multiDeleteTn_form_VI = async (ids) => {
    try {
        const token = sessionStorage.getItem('token');
        const response = await api.post(`/delete_multiple_tn_form_vi`, ids, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })
        return response.data;
    } catch (error) {
        throw error.response ? error.response.data.error : error.message;
    }
}


